<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "taskDetail"
}
</script>

<style scoped>

</style>
